export enum LoginState {
  LOGGED,
  PENDING,
  NOT_LOGGED,
  LOGIN_REJECTED,
  LOGGING_OUT
}
